import { Box, Button } from "@mui/material";
import { MdCheck } from "react-icons/md";

export default function TeamPricingActions({
  disabled,
  isPending,
  onSave,
}) {
  return (
    <Box className="mt-6 flex justify-end">
      <Button
        variant="contained"
        startIcon={<MdCheck />}
        onClick={onSave}
        disabled={disabled}
        sx={{
          bgcolor: "#1F4FFF",
          textTransform: "none",
          px: 4,
          py: 1.5,
          borderRadius: "10px",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "#1a40d9",
          },
          "&.Mui-disabled": {
            bgcolor: "#94A3B8",
            color: "#F8FAFC",
          },
        }}
      >
        {isPending ? "Saving..." : "Save Configuration"}
      </Button>
    </Box>
  );
}
